var _rect, _path, _path2, _path3, _path4, _line, _line2, _line3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.72,
    y: 3.199,
    width: 36.561,
    height: 35.602,
    rx: 4.69,
    ry: 4.69
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.72,12.615c.71,1.679,2.373,2.857,4.31,2.857,2.583,0,4.678-2.094,4.678-4.678"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.707,11.613c0,2.583,2.094,4.678,4.678,4.678s4.678-2.094,4.678-4.678"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.063,11.613c0,2.583,2.094,4.678,4.678,4.678s4.678-2.094,4.678-4.678"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.418,10.794c0,2.583,2.094,4.678,4.678,4.678,1.831,0,3.417-1.052,4.185-2.586"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.165,
    y1: 7.496,
    x2: 11.602,
    y2: 11.552
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.063,
    y1: 7.289,
    x2: 21.063,
    y2: 11.861
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30.001,
    y1: 7.548,
    x2: 30.557,
    y2: 11.559
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.799,
    y: 24.399,
    width: 14.403,
    height: 14.403
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorShop);
export default __webpack_public_path__ + "static/media/indoor-shop.8db5ed03e2d0947f7a645b706d7c9c34.svg";
export { ForwardRef as ReactComponent };